import { render, staticRenderFns } from "./home-show.vue?vue&type=template&id=276a45af&"
import script from "./home-show.vue?vue&type=script&lang=js&"
export * from "./home-show.vue?vue&type=script&lang=js&"
import style0 from "./home-show.vue?vue&type=style&index=0&id=276a45af&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports